// extracted by mini-css-extract-plugin
export default {"homeTasks":"HomeTasks_homeTasks__PuGdj","list":"HomeTasks_list__JTmYg","empty":"HomeTasks_empty__VrrQs"};